import { css } from '@emotion/react';
import { type FC } from 'react';
import { SwitchOptionsComponent } from '~/_shared/components/switchOptions/switchOptions.component';
import { type MapInfo } from '~/_shared/types/map';
import { useTranslation } from '~/_shared/utils/hooks';

const containerStyle = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: '12px 16px',
});

const containerDisabledStyle = css({
  opacity: .5,
});

const mapNameLabelStyle = css({
  marginBottom: 15,
  fontWeight: 800,
});

const updatesLabelStyle = css({
  margin: '10px 0 0',
});

type ConnectivitySettingsProps = Readonly<{
  isDisabled?: boolean;
  mapInfo: MapInfo | null;
  onDisconnectMap: () => void;
}>;

export const ConnectivitySettingsComponent: FC<ConnectivitySettingsProps> = ({
  isDisabled,
  mapInfo,
  onDisconnectMap,
}) => {
  const [t] = useTranslation();

  const isConnected = !!mapInfo?.layering?.connected;

  return (
    <div
      css={[containerStyle, isConnected ? null : containerDisabledStyle]}
    >
      <span css={mapNameLabelStyle}>{mapInfo?.name}</span>
      <SwitchOptionsComponent
        isDisabled={isDisabled || !mapInfo?.layering?.connected}
        options={[{
          value: true,
          label: t('Connected').toUpperCase(),
        }, {
          value: false,
          label: t('Disconnect').toUpperCase(),
        }]}
        value={isConnected}
        onChange={(newValue) => {
          if (newValue) {
            return;
          }
          onDisconnectMap();
        }}
      />
      {mapInfo?.layering?.connected && (
        <p css={updatesLabelStyle}>
          {mapInfo?.layering?.realTime ? t('UPDATES: in real time') : t('UPDATES: need to be approved')}
        </p>
      )}
    </div>
  );
};
